export type WorkScheduleRowsDisplayType = 1 | 2;

interface IWorkScheduleRowsDisplayTypeEnum {
    Horizontal: WorkScheduleRowsDisplayType;
    Vertical: WorkScheduleRowsDisplayType;
    format(value: number): string | undefined;
    displayTypesArray(): any[];
}

const dataSource = () => [
    { key: 1, text: 'Horizontalus' },
    { key: 2, text: 'Vertikalus' }
];

export const workScheduleRowsDisplayType: IWorkScheduleRowsDisplayTypeEnum = {
    Horizontal: 1,
    Vertical: 2,
    format(value: number) {
        const item = dataSource().find(x => x.key === value);
        return item && item.text;
    },
    displayTypesArray() {
        let types: any[] = [];
        dataSource().map(x => {
            types.push(x);
        });
        return types;
    }
};
